<template>
  <div
    :class="[
      $style['price'],
      { [$style['price--has-sale']]: props.sale },
      { [$style['price--large']]: props.large },
      { [$style['price--vertical']]: props.vertical }
    ]">
    <span
      v-if="sale && sale !== price"
      :class="$style['old-price']">{{ sale.split(',')[0] }},<sup>{{
        sale.split(',')[1]
      }}</sup></span>
    <span :class="$style['price__current']">{{ price.split(',')[0] }},<sup>{{
      price.split(',')[1]
    }}</sup></span>

    <span
      v-if="percent"
      shadow
      :class="$style['percent']"
      type="sale">
      -{{ percent }}%
    </span>
  </div>
</template>

<script setup>

const props = defineProps({
  price: {
    type: String,
    default: null
  },
  vertical: {
    type: Boolean,
    default: false
  },
  large: {
    type: Boolean,
    default: false
  },
  sale: {
    type: [String, Boolean, Number],
    default: null
  },
  percent: {
    type: [Number, Boolean],
    default: null
  }
})
</script>
<style lang="scss" module>
.price {
  align-items: center;
  justify-content: center;
  flex-direction: row;
  color: $black;
  display: inline-flex;
  text-align: center;
  font-size: $font-size-s;
  font-weight: $font-weight-normal;
  line-height: 1.25;
  white-space: nowrap;
  position: relative;

  @media (min-width: #{$breakpoint-small-desktop}) {
    font-size: $font-size;
  }

  sup {
    top: -0.2em;
    font-size: 0.75em;
    position: relative;
  }

  .price__current {
    font-size: 1rem;
  }

  &--has-sale {
    flex-direction: row;

    .old-price {
      margin-right: $spacing * 1.3;
      color: $grey-dark;
      font-size: $font-size-s;
      position: relative;

      &::after {
        border-top: 1px solid currentcolor;
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        width: auto;
        transform: scaleX(1.2) rotate(-5deg);
      }
    }

    .price__current {
      color: $red;
      font-size: 1.1rem;
      margin-right: $spacing;
    }

    .percent {
      color: $white;
      background-color: $black;
      font-size: $font-size-xxs;
      border-radius: 3px;
      font-weight: 600;
      padding: $spacing * 0.5;
      line-height: .8;
    }
  }

  &--vertical {
    align-items: flex-end;
    flex-direction: column;

    .old-price {
      font-size: $font-size-s;
      margin-right: 0;
    }

  }

  &--large.price {
    font-size: $font-size-m;

    sup {
      top: -0.25em;
    }
  }
}
</style>
